// Verified against the customer brief; see docs/brand-sources.md.
export const BRAND_LOGOS = [
  {
    "name": "Lyle & Scott",
    "src": "/assets/brands/lyle-scott.svg",
    "width": 146,
    "height": 25
  },
  {
    "name": "Lacoste",
    "src": "/assets/brands/lacoste.svg",
    "width": 100,
    "height": 66
  },
  {
    "name": "Salomon",
    "src": "/assets/brands/salomon.webp",
    "width": 142,
    "height": 36
  },
  {
    "name": "Asics",
    "src": "/assets/brands/asics.svg",
    "width": 118,
    "height": 39
  },
  {
    "name": "Björn Borg",
    "src": "/assets/brands/bjorn-borg.svg",
    "width": 146,
    "height": 24
  },
  {
    "name": "Defender",
    "src": "/assets/brands/defender.webp",
    "width": 114,
    "height": 51
  },
  {
    "name": "Only & Sons",
    "src": "/assets/brands/only-sons.svg",
    "width": 142,
    "height": 36
  },
  {
    "name": "Tenson",
    "src": "/assets/brands/tenson.svg",
    "width": 142,
    "height": 36
  },
  {
    "name": "Helly Hansen",
    "src": "/assets/brands/helly-hansen.webp",
    "width": 72,
    "height": 56
  },
  {
    "name": "Cobolt",
    "src": "/assets/brands/cobolt.webp",
    "width": 128,
    "height": 57,
    "monochrome": true
  },
  {
    "name": "Bagheera",
    "src": "/assets/brands/bagheera.webp",
    "width": 100,
    "height": 57
  },
  {
    "name": "Only",
    "src": "/assets/brands/only.svg",
    "width": 142,
    "height": 36
  },
  {
    "name": "Mingel",
    "src": "/assets/brands/mingel.webp",
    "width": 140,
    "height": 24
  },
  {
    "name": "Soda Collection",
    "src": "/assets/brands/soda.webp",
    "width": 142,
    "height": 71
  },
  {
    "name": "Zink",
    "src": "/assets/brands/zink.webp",
    "width": 126,
    "height": 42
  },
  {
    "name": "Marine",
    "src": "/assets/brands/marine.webp",
    "width": 142,
    "height": 36
  },
  {
    "name": "Daily Sports",
    "src": "/assets/brands/daily-sports.webp",
    "width": 142,
    "height": 36
  },
  {
    "name": "Röhnisch",
    "src": "/assets/brands/rohnisch.svg",
    "width": 146,
    "height": 22
  },
  {
    "name": "Hoka",
    "src": "/assets/brands/hoka.svg",
    "width": 142,
    "height": 36,
    "monochrome": true
  },
  {
    "name": "Skechers",
    "src": "/assets/brands/skechers.webp",
    "width": 146,
    "height": 22
  },
  {
    "name": "Didriksons",
    "src": "/assets/brands/didriksons.svg",
    "width": 142,
    "height": 36
  },
  {
    "name": "CAT",
    "src": "/assets/brands/cat.svg",
    "width": 76,
    "height": 57
  },
  {
    "name": "Lee",
    "src": "/assets/brands/lee.svg",
    "width": 100,
    "height": 52
  },
  {
    "name": "Wrangler",
    "src": "/assets/brands/wrangler.svg",
    "width": 142,
    "height": 36
  },
  {
    "name": "Puma",
    "src": "/assets/brands/puma.svg",
    "width": 76,
    "height": 58
  }
];
